import { URLS } from 'constants/api.constants';
import { axiosInstance } from 'utils/axios';

const { createAsyncThunk } = require('@reduxjs/toolkit');

export const getTermsUseInfo = createAsyncThunk(
  'get/termsOfUse',
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(URLS.TERM_OF_USE.GET_TERM_CONTENT);
      if (response?.data?.success) {
        return response?.data;
      }else{
        return rejectWithValue(response?.data?.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
